import { FC, useMemo } from "react";
import mileageTranslationsHelper from "../../../../languages/mileage-translations.helper";
import ModalComponent from "../../../../common/components/modal/modal.component";
import ButtonComponent from "../../../../common/components/button/button.component";
import MileageListingFilter from "../common/types/mileage-listing-filter";
import mileageListingFilterHelper from "../filter/mileage-listing-filters.helper";
import listingFilterFactory from "../../../../common/components/listing/filter/listing-filter.factory";
import ListingFilterBadgeComponent from "../../../../common/components/listing/filter/badge/listing-filter-badge.component";

type MileageListingAutoGenerateModalProps = {
  isOpen: boolean;
  onSuccessClick: () => void;
  onCloseClick: () => void;
  filters: MileageListingFilter[];
  onFiltersChange: (appliedFilters: MileageListingFilter[]) => void;
};

const MileageListingAutoGenerateModalComponent: FC<
  MileageListingAutoGenerateModalProps
> = (props) => {
  const translations =
    mileageTranslationsHelper.getMileageListingTranslations().autoGenerate;

  const filterDefinition = useMemo(() => {
    return mileageListingFilterHelper().getFilterDefinition();
  }, []);

  const badges = listingFilterFactory.createFilterBadges(
    filterDefinition,
    props.filters,
  );

  const onFiltersDelete = (index: number) => {
    const newAppliedFilters: MileageListingFilter[] = props.filters.filter(
      (_filter, filterIndex) => index !== filterIndex,
    );

    props.onFiltersChange(newAppliedFilters);
  };

  return (
    <ModalComponent
      header={{ title: translations.headingLabel }}
      isOpen={props.isOpen}
      onClose={props.onCloseClick}
      actions={[
        <ButtonComponent
          onClick={props.onSuccessClick}
          type="success"
          title={translations.submitButtonTitle}
        >
          {translations.submitButtonLabel}
        </ButtonComponent>,
        <ButtonComponent
          onClick={props.onCloseClick}
          type="brand"
          title={translations.cancelButtonTitle}
        >
          {translations.cancelButtonLabel}
        </ButtonComponent>,
      ]}
    >
      <div className="mileage_listing_auto_generate_modal">
        <div className="mileage_listing_auto_generate_modal__heading">
          <strong>{translations.filtersLabel}</strong>
        </div>
        {badges && badges.length > 0 ? (
          badges.map((badge, index) => {
            return (
              <ListingFilterBadgeComponent
                key={index}
                title={badge.title}
                text={badge.text}
                onDeleteButtonClick={() => onFiltersDelete(index)}
              />
            );
          })
        ) : (
          <div className="mileage_listing_auto_generate_modal__heading">
            {translations.noFiltersLabel}
          </div>
        )}
      </div>
    </ModalComponent>
  );
};

export default MileageListingAutoGenerateModalComponent;
